import {openResourceModal} from '../../core/modalCommand';
import {
	MULTI_PSK_CREATE_MODAL_EVENT,
	MULTI_PSK_DELETE_MODAL_EVENT,
	MULTI_PSK_EDIT_MODAL_EVENT,
} from './events';

/**
 * Open Add Multi PSK.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openMultiPskCreateModal(command, envelope) {
	return openResourceModal(MULTI_PSK_CREATE_MODAL_EVENT, command, envelope);
}

/**
 * Open Edit Multi PSK.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openMultiPskEditModal(command, envelope) {
	return openResourceModal(MULTI_PSK_EDIT_MODAL_EVENT, command, envelope);
}

/**
 * Open Delete Multi PSK.
 *
 * The confirmation, not the deletion. Nothing is removed until the
 * person presses the button inside it.
 * @param {object} command modal command
 * @param {object} envelope request correlation
 * @return {Promise<void>} modal acknowledgement
 */
export function openMultiPskDeleteModal(command, envelope) {
	return openResourceModal(MULTI_PSK_DELETE_MODAL_EVENT, command, envelope);
}
